import { StyleSheet, View } from 'react-native'
import { Color, Spacing, Text } from 'zens-storybook'
import { useTranslation } from 'react-i18next'

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center' },
  swatch: {
    width: 16,
    height: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Color.calmGrey,
    marginRight: Spacing.XS,
  },
})

export const OCCUPANCY_COLOR_LABELS = {
  red: 'Red',
  blue: 'Blue',
  orange: 'Orange',
  yellow: 'Yellow',
  purple: 'Purple',
  green: 'Green'
}

const OccupancyColor = ({ value }: { value: string }) => {
  const { t } = useTranslation()
  return (
    <View style={styles.row}>
      <View
        testID={`OccupancyColor.${value}`}
        style={[styles.swatch, { backgroundColor: Color[value as keyof typeof Color] || Color.calmGrey }]}
      />
      <Text>{t(OCCUPANCY_COLOR_LABELS[value as keyof typeof OCCUPANCY_COLOR_LABELS] || value)}</Text>
    </View>
  )
}

export default OccupancyColor
